import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
function Badges(_ref) {
  var submenuTitle = _ref.submenuTitle,
    menuItemTitle = _ref.menuItemTitle,
    options = _ref.options,
    selections = _ref.selections,
    handleSelection = _ref.handleSelection;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "subcontent-title"
  }, submenuTitle), /*#__PURE__*/React.createElement("div", {
    className: "badges"
  }, options.map(function (_ref2) {
    var value = _ref2.value,
      label = _ref2.label;
    var exists = submenuTitle ? selections[menuItemTitle][submenuTitle].includes(label) : selections[menuItemTitle].includes(label);
    return /*#__PURE__*/React.createElement("span", {
      className: "badge ".concat(exists ? 'active' : ''),
      key: value,
      role: "link",
      tabIndex: 0,
      onClick: function onClick() {
        if (submenuTitle) handleSelection(menuItemTitle, label, submenuTitle);
      }
    }, label);
  })));
}
Badges.propTypes = {
  submenuTitle: PropTypes.string,
  menuItemTitle: PropTypes.string.isRequired,
  options: PropTypes.instanceOf(Array).isRequired,
  selections: PropTypes.shape({}).isRequired,
  handleSelection: PropTypes.func.isRequired
};
Badges.defaultProps = {
  submenuTitle: null
};
export default Badges;